import { inject, Injectable } from '@angular/core';
import { CryptoUtilsService } from 'src/app/shared/services/crypto-utils.service';
import { WebsocketParams } from './websocket-params';
import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';
import { MemberType } from './member-type';

@Injectable({
  providedIn: 'root',
})
export class StreamerWebsocketParamsService {
  public static readonly STREAMER_MEMBER_ID_KEY = 'streamer-member-id';

  crypto = inject(CryptoUtilsService);
  localStoreService = inject(LocalStorageHelperService);

  create(
    memberDisplayName: StreamerWebsocketParams['memberDisplayName'],
    joinCode: StreamerWebsocketParams['joinCode'],
    securityPin?: StreamerWebsocketParams['securityPin'],
    token?: StreamerWebsocketParams['token'],
  ): StreamerWebsocketParams {
    return new StreamerWebsocketParams(
      memberDisplayName,
      joinCode,
      securityPin,
      token,
      this.getMemberId(),
    );
  }

  private getMemberId() {
    let memberId = this.localStoreService.get(
      StreamerWebsocketParamsService.STREAMER_MEMBER_ID_KEY,
    );
    if (memberId) {
      return memberId;
    }

    memberId = this.crypto.randomUUID();
    this.localStoreService.set(
      StreamerWebsocketParamsService.STREAMER_MEMBER_ID_KEY,
      memberId,
    );
    return memberId;
  }
}

class StreamerWebsocketParams implements Pick<
  WebsocketParams,
  | 'memberType'
  | 'memberDisplayName'
  | 'joinCode'
  | 'securityPin'
  | 'token'
  | 'memberId'
> {
  memberType: Required<WebsocketParams>['memberType'] = MemberType.STREAMER;

  constructor(
    public memberDisplayName: Required<WebsocketParams>['memberDisplayName'],
    public joinCode: Required<WebsocketParams>['joinCode'],
    public securityPin?: Required<WebsocketParams>['securityPin'],
    public token?: Required<WebsocketParams>['token'],
    public memberId?: Required<WebsocketParams>['memberId'],
  ) {}

  asQueryParams() {
    const params = new URLSearchParams();
    params.append('memberType', this.memberType);
    params.append('memberDisplayName', this.memberDisplayName);
    params.append('joinCode', this.joinCode);
    params.append('memberId', this.memberId);
    if (this.securityPin) params.append('securityPin', this.securityPin);
    if (this.token) params.append('token', `Bearer ${this.token}`);
    return params.toString();
  }

  isModerator() {
    return false;
  }
}
